// removed by extract-text-webpack-plugin
module.exports = {"container":"container___1DXjf","swatchContainer":"swatchContainer___1kLEX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Grid/Grid.module.css
// module id = 321
// module chunks = 0